/**
 * Copyright (c) 2021 BlockDev AG
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

export const formatMYST = (amountString: string): number => {
    let amount = parseInt(amountString, 10);
    if (amount === 0) {
        return 0;
    }
    return amount / 1000000000000000000;
};

export const errorReload = () => {
    setTimeout(() => {
        window.location.reload();
    }, 700);
};
